export const FileIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_399_1592)">
      <path
        d="M5 18.3333V3.33333C5 2.8913 5.17559 2.46738 5.48816 2.15482C5.80072 1.84226 6.22464 1.66667 6.66667 1.66667H13.3333C13.7754 1.66667 14.1993 1.84226 14.5118 2.15482C14.8244 2.46738 15 2.8913 15 3.33333V18.3333H5Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 10H3.33333C2.89131 10 2.46738 10.1756 2.15482 10.4882C1.84226 10.8007 1.66667 11.2246 1.66667 11.6667V16.6667C1.66667 17.1087 1.84226 17.5326 2.15482 17.8452C2.46738 18.1577 2.89131 18.3333 3.33333 18.3333H5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 7.5H16.6667C17.1087 7.5 17.5326 7.6756 17.8452 7.98816C18.1577 8.30072 18.3333 8.72464 18.3333 9.16667V16.6667C18.3333 17.1087 18.1577 17.5326 17.8452 17.8452C17.5326 18.1577 17.1087 18.3333 16.6667 18.3333H15"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33333 5H11.6667"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33333 8.33333H11.6667"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33333 11.6667H11.6667"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33333 15H11.6667"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_399_1592">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const UsersIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 17.5V15.8333C13.3333 14.9493 12.9821 14.1014 12.357 13.4763C11.7319 12.8512 10.8841 12.5 10 12.5H5C4.11594 12.5 3.2681 12.8512 2.64298 13.4763C2.01786 14.1014 1.66667 14.9493 1.66667 15.8333V17.5"
      stroke="#DCE5E0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 9.16667C9.34095 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34095 2.5 7.5 2.5C5.65905 2.5 4.16667 3.99238 4.16667 5.83333C4.16667 7.67428 5.65905 9.16667 7.5 9.16667Z"
      stroke="#DCE5E0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3333 17.5V15.8333C18.3328 15.0948 18.087 14.3773 17.6345 13.7936C17.182 13.2099 16.5484 12.793 15.8333 12.6083"
      stroke="#DCE5E0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 2.60833C14.0503 2.79192 14.6859 3.20892 15.1397 3.79359C15.5935 4.37827 15.8399 5.09736 15.8399 5.8375C15.8399 6.57764 15.5935 7.29673 15.1397 7.88141C14.6859 8.46608 14.0503 8.88308 13.3333 9.06667"
      stroke="#DCE5E0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StarIcon = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6972 17.3096C13.4599 17.3098 13.2262 17.2518 13.0165 17.1409L9.12092 15.0934C9.09073 15.0772 9.05703 15.0688 9.0228 15.0688C8.98856 15.0688 8.95486 15.0772 8.92467 15.0934L5.02967 17.1409C4.7883 17.2679 4.5162 17.3248 4.24416 17.3052C3.97211 17.2856 3.71098 17.1903 3.49032 17.0299C3.26966 16.8696 3.09826 16.6508 2.99554 16.3981C2.89281 16.1454 2.86285 15.8691 2.90905 15.6003L3.6528 11.2634C3.65851 11.2294 3.6558 11.1945 3.6449 11.1618C3.63401 11.1291 3.61526 11.0996 3.5903 11.0759L0.441546 8.00275C0.246048 7.81228 0.107802 7.57087 0.0424734 7.30586C-0.0228551 7.04085 -0.012655 6.76284 0.071918 6.50333C0.156491 6.24382 0.312056 6.01319 0.520987 5.83756C0.729918 5.66193 0.983862 5.54833 1.25405 5.50963L5.60592 4.87775C5.63978 4.87283 5.67194 4.85972 5.6996 4.83957C5.72726 4.81943 5.74959 4.79285 5.76467 4.76213L7.7103 0.815252C7.83081 0.570577 8.01742 0.364532 8.24899 0.220449C8.48057 0.0763654 8.74787 0 9.02061 0C9.29335 0 9.56065 0.0763654 9.79222 0.220449C10.0238 0.364532 10.2104 0.570577 10.3309 0.815252L12.2778 4.76088C12.293 4.7915 12.3154 4.818 12.343 4.83813C12.3706 4.85826 12.4027 4.87142 12.4365 4.8765L16.7922 5.509C17.0622 5.54793 17.316 5.66165 17.5248 5.8373C17.7336 6.01296 17.889 6.24354 17.9735 6.50295C18.0581 6.76237 18.0683 7.04027 18.0032 7.30521C17.938 7.57015 17.7999 7.81156 17.6047 8.00213L14.4528 11.0734C14.4279 11.0972 14.4092 11.1267 14.3983 11.1594C14.3875 11.1921 14.3847 11.2269 14.3903 11.2609L15.134 15.5978C15.1698 15.8073 15.1595 16.0221 15.1038 16.2273C15.0481 16.4324 14.9484 16.623 14.8116 16.7857C14.6748 16.9484 14.5041 17.0793 14.3116 17.1694C14.119 17.2594 13.9091 17.3064 13.6965 17.3071L13.6972 17.3096ZM9.0228 13.8184C9.25983 13.8183 9.49329 13.8763 9.7028 13.9871L13.5978 16.034C13.6323 16.0537 13.6718 16.0627 13.7114 16.06C13.751 16.0572 13.7889 16.0427 13.8203 16.0184C13.853 15.9959 13.8785 15.9643 13.8935 15.9276C13.9085 15.8908 13.9124 15.8505 13.9047 15.8115L13.1603 11.474C13.1205 11.2406 13.138 11.001 13.2111 10.7757C13.2843 10.5505 13.411 10.3464 13.5803 10.1809L16.7322 7.109C16.7603 7.08145 16.7802 7.04658 16.7896 7.00832C16.7989 6.97007 16.7974 6.92996 16.7852 6.89252C16.773 6.85508 16.7505 6.8218 16.7204 6.79644C16.6903 6.77108 16.6536 6.75465 16.6147 6.749L12.2597 6.11588C12.0252 6.08193 11.8025 5.99141 11.6109 5.85213C11.4192 5.71286 11.2644 5.52902 11.1597 5.3165L9.2103 1.37025C9.19284 1.33494 9.16585 1.30521 9.13239 1.28442C9.09893 1.26363 9.06032 1.25262 9.02092 1.25262C8.98153 1.25262 8.94292 1.26363 8.90945 1.28442C8.87599 1.30521 8.849 1.33494 8.83155 1.37025L6.88592 5.31525C6.78117 5.52785 6.62621 5.71174 6.43444 5.85102C6.24267 5.99029 6.01987 6.08077 5.7853 6.11463L1.43092 6.749C1.39186 6.75453 1.35514 6.77091 1.32494 6.79628C1.29474 6.82165 1.27227 6.85499 1.26009 6.89251C1.24791 6.93003 1.24651 6.97021 1.25605 7.00849C1.26559 7.04676 1.28568 7.08159 1.31405 7.109L4.4653 10.1809C4.63464 10.3464 4.76132 10.5505 4.83447 10.7757C4.90762 11.001 4.92506 11.2406 4.8853 11.474L4.14092 15.8115C4.13417 15.8505 4.13849 15.8906 4.1534 15.9272C4.1683 15.9638 4.19319 15.9955 4.22523 16.0187C4.25727 16.0419 4.29518 16.0556 4.33464 16.0583C4.3741 16.061 4.41352 16.0526 4.44842 16.034L8.3428 13.9865C8.55245 13.8761 8.78584 13.8184 9.0228 13.8184Z"
      fill="white"
    />
  </svg>
);

export const DealsIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_399_1614)">
      <path
        d="M10.4883 2.15501C10.1758 1.84242 9.75199 1.66677 9.31 1.66667H3.33333C2.89131 1.66667 2.46738 1.84227 2.15482 2.15483C1.84226 2.46739 1.66667 2.89131 1.66667 3.33334V9.31001C1.66676 9.752 1.84242 10.1759 2.155 10.4883L9.40833 17.7417C9.7871 18.118 10.2994 18.3293 10.8333 18.3293C11.3673 18.3293 11.8796 18.118 12.2583 17.7417L17.7417 12.2583C18.118 11.8796 18.3293 11.3673 18.3293 10.8333C18.3293 10.2994 18.118 9.7871 17.7417 9.40834L10.4883 2.15501Z"
        stroke="#DCE5E0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 6.66666C6.48012 6.66666 6.66667 6.48011 6.66667 6.24999C6.66667 6.01988 6.48012 5.83333 6.25 5.83333C6.01988 5.83333 5.83333 6.01988 5.83333 6.24999C5.83333 6.48011 6.01988 6.66666 6.25 6.66666Z"
        fill="#DCE5E0"
        stroke="#DCE5E0"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_399_1614">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DealsImgicon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z"
      stroke="#DCE5E0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 9.16666C8.42048 9.16666 9.16667 8.42047 9.16667 7.49999C9.16667 6.57952 8.42048 5.83333 7.5 5.83333C6.57953 5.83333 5.83333 6.57952 5.83333 7.49999C5.83333 8.42047 6.57953 9.16666 7.5 9.16666Z"
      stroke="#DCE5E0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5 12.5L14.9283 9.92833C14.6158 9.61588 14.1919 9.44035 13.75 9.44035C13.3081 9.44035 12.8842 9.61588 12.5717 9.92833L5 17.5"
      stroke="#DCE5E0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Settingsicon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1833 1.66667H9.81667C9.37464 1.66667 8.95072 1.84227 8.63816 2.15483C8.32559 2.46739 8.15 2.89131 8.15 3.33334V3.48334C8.1497 3.77561 8.07255 4.06266 7.92628 4.3157C7.78002 4.56874 7.56978 4.77887 7.31667 4.925L6.95833 5.13334C6.70497 5.27962 6.41756 5.35663 6.125 5.35663C5.83244 5.35663 5.54503 5.27962 5.29167 5.13334L5.16667 5.06667C4.78422 4.84606 4.32986 4.78621 3.90333 4.90026C3.47681 5.01431 3.11296 5.29295 2.89167 5.675L2.70833 5.99167C2.48772 6.37412 2.42787 6.82847 2.54192 7.255C2.65598 7.68153 2.93461 8.04538 3.31667 8.26667L3.44167 8.35C3.69356 8.49543 3.90302 8.70424 4.04921 8.9557C4.1954 9.20715 4.27324 9.49248 4.275 9.78334V10.2083C4.27617 10.502 4.19971 10.7908 4.05337 11.0454C3.90703 11.3001 3.69601 11.5115 3.44167 11.6583L3.31667 11.7333C2.93461 11.9546 2.65598 12.3185 2.54192 12.745C2.42787 13.1715 2.48772 13.6259 2.70833 14.0083L2.89167 14.325C3.11296 14.7071 3.47681 14.9857 3.90333 15.0997C4.32986 15.2138 4.78422 15.154 5.16667 14.9333L5.29167 14.8667C5.54503 14.7204 5.83244 14.6434 6.125 14.6434C6.41756 14.6434 6.70497 14.7204 6.95833 14.8667L7.31667 15.075C7.56978 15.2211 7.78002 15.4313 7.92628 15.6843C8.07255 15.9373 8.1497 16.2244 8.15 16.5167V16.6667C8.15 17.1087 8.32559 17.5326 8.63816 17.8452C8.95072 18.1577 9.37464 18.3333 9.81667 18.3333H10.1833C10.6254 18.3333 11.0493 18.1577 11.3618 17.8452C11.6744 17.5326 11.85 17.1087 11.85 16.6667V16.5167C11.8503 16.2244 11.9275 15.9373 12.0737 15.6843C12.22 15.4313 12.4302 15.2211 12.6833 15.075L13.0417 14.8667C13.295 14.7204 13.5824 14.6434 13.875 14.6434C14.1676 14.6434 14.455 14.7204 14.7083 14.8667L14.8333 14.9333C15.2158 15.154 15.6701 15.2138 16.0967 15.0997C16.5232 14.9857 16.887 14.7071 17.1083 14.325L17.2917 14C17.5123 13.6176 17.5721 13.1632 17.4581 12.7367C17.344 12.3101 17.0654 11.9463 16.6833 11.725L16.5583 11.6583C16.304 11.5115 16.093 11.3001 15.9466 11.0454C15.8003 10.7908 15.7238 10.502 15.725 10.2083V9.79167C15.7238 9.49799 15.8003 9.20921 15.9466 8.95458C16.093 8.69995 16.304 8.48851 16.5583 8.34167L16.6833 8.26667C17.0654 8.04538 17.344 7.68153 17.4581 7.255C17.5721 6.82847 17.5123 6.37412 17.2917 5.99167L17.1083 5.675C16.887 5.29295 16.5232 5.01431 16.0967 4.90026C15.6701 4.78621 15.2158 4.84606 14.8333 5.06667L14.7083 5.13334C14.455 5.27962 14.1676 5.35663 13.875 5.35663C13.5824 5.35663 13.295 5.27962 13.0417 5.13334L12.6833 4.925C12.4302 4.77887 12.22 4.56874 12.0737 4.3157C11.9275 4.06266 11.8503 3.77561 11.85 3.48334V3.33334C11.85 2.89131 11.6744 2.46739 11.3618 2.15483C11.0493 1.84227 10.6254 1.66667 10.1833 1.66667Z"
      stroke="#DCE5E0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
      stroke="#DCE5E0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UploadArrow = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#235C49" fill-opacity="0.1" />
    <path
      d="M31.5 26.5V29.8333C31.5 30.2754 31.3244 30.6993 31.0118 31.0118C30.6993 31.3244 30.2754 31.5 29.8333 31.5H18.1667C17.7246 31.5 17.3007 31.3244 16.9882 31.0118C16.6756 30.6993 16.5 30.2754 16.5 29.8333V26.5"
      stroke="#628478"
      strokeidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.1667 20.6667L24 16.5L19.8333 20.6667"
      stroke="#628478"
      strokeidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 16.5V26.5"
      stroke="#628478"
      strokeidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LocationIconGreen = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3334 6.66667C13.3334 9.99534 9.64069 13.462 8.40069 14.5327C8.28517 14.6195 8.14455 14.6665 8.00002 14.6665C7.85549 14.6665 7.71487 14.6195 7.59935 14.5327C6.35935 13.462 2.66669 9.99534 2.66669 6.66667C2.66669 5.25218 3.22859 3.89563 4.22878 2.89543C5.22898 1.89524 6.58553 1.33334 8.00002 1.33334C9.41451 1.33334 10.7711 1.89524 11.7713 2.89543C12.7715 3.89563 13.3334 5.25218 13.3334 6.66667Z"
      stroke="#628478"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8.66666C9.10457 8.66666 10 7.77123 10 6.66666C10 5.56209 9.10457 4.66666 8 4.66666C6.89543 4.66666 6 5.56209 6 6.66666C6 7.77123 6.89543 8.66666 8 8.66666Z"
      stroke="#628478"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhoneGreenIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_399_1688)">
      <path
        d="M14.6666 11.28V13.28C14.6674 13.4657 14.6294 13.6494 14.555 13.8196C14.4806 13.9897 14.3715 14.1424 14.2347 14.2679C14.0979 14.3934 13.9364 14.489 13.7605 14.5485C13.5846 14.608 13.3982 14.63 13.2133 14.6133C11.1619 14.3904 9.19131 13.6894 7.45998 12.5667C5.84919 11.5431 4.48353 10.1774 3.45998 8.56667C2.33329 6.82747 1.63214 4.84733 1.41331 2.78667C1.39665 2.60231 1.41856 2.41651 1.47764 2.24108C1.53673 2.06566 1.63169 1.90446 1.75649 1.76775C1.88128 1.63103 2.03318 1.5218 2.2025 1.44701C2.37183 1.37222 2.55487 1.33351 2.73998 1.33333H4.73998C5.06351 1.33015 5.37717 1.44472 5.62248 1.65569C5.8678 1.86666 6.02803 2.15963 6.07331 2.48C6.15772 3.12004 6.31428 3.74848 6.53998 4.35333C6.62967 4.59195 6.64908 4.85127 6.59591 5.10059C6.54274 5.3499 6.41922 5.57874 6.23998 5.76L5.39331 6.60667C6.34235 8.2757 7.72428 9.65763 9.39331 10.6067L10.24 9.76C10.4212 9.58076 10.6501 9.45723 10.8994 9.40406C11.1487 9.35089 11.408 9.3703 11.6466 9.46C12.2515 9.6857 12.8799 9.84225 13.52 9.92667C13.8438 9.97235 14.1396 10.1355 14.351 10.385C14.5624 10.6345 14.6748 10.953 14.6666 11.28Z"
        stroke="#628478"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_399_1688">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MailGreenIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 2.66667H2.66665C1.93027 2.66667 1.33331 3.26363 1.33331 4.00001V12C1.33331 12.7364 1.93027 13.3333 2.66665 13.3333H13.3333C14.0697 13.3333 14.6666 12.7364 14.6666 12V4.00001C14.6666 3.26363 14.0697 2.66667 13.3333 2.66667Z"
      stroke="#628478"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6666 4.66667L8.68665 8.46667C8.48083 8.59562 8.24286 8.66401 7.99998 8.66401C7.7571 8.66401 7.51913 8.59562 7.31331 8.46667L1.33331 4.66667"
      stroke="#628478"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WebGreenIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_399_1694)">
      <path
        d="M7.99998 14.6667C11.6819 14.6667 14.6666 11.6819 14.6666 8.00001C14.6666 4.31811 11.6819 1.33334 7.99998 1.33334C4.31808 1.33334 1.33331 4.31811 1.33331 8.00001C1.33331 11.6819 4.31808 14.6667 7.99998 14.6667Z"
        stroke="#628478"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99998 1.33334C6.28814 3.13078 5.33331 5.51784 5.33331 8.00001C5.33331 10.4822 6.28814 12.8692 7.99998 14.6667C9.71182 12.8692 10.6666 10.4822 10.6666 8.00001C10.6666 5.51784 9.71182 3.13078 7.99998 1.33334Z"
        stroke="#628478"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33331 8H14.6666"
        stroke="#628478"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_399_1694">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LinkGreenIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99998 11.3333H4.66665C3.78259 11.3333 2.93474 10.9821 2.30962 10.357C1.6845 9.73189 1.33331 8.88404 1.33331 7.99999C1.33331 7.11593 1.6845 6.26809 2.30962 5.64297C2.93474 5.01785 3.78259 4.66666 4.66665 4.66666H5.99998"
      stroke="#628478"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.66666H11.3333C12.2174 4.66666 13.0652 5.01785 13.6904 5.64297C14.3155 6.26809 14.6667 7.11593 14.6667 7.99999C14.6667 8.88404 14.3155 9.73189 13.6904 10.357C13.0652 10.9821 12.2174 11.3333 11.3333 11.3333H10"
      stroke="#628478"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33331 8H10.6666"
      stroke="#628478"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EditPenIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.975 11.7562H3.04375L4.875 11.5875C5.13125 11.5625 5.36875 11.45 5.55 11.2688L12.4625 4.35625C12.7875 4.03125 12.9688 3.6 12.9688 3.14375C12.9688 2.6875 12.7875 2.25625 12.4625 1.93125L12.0188 1.4875C11.3688 0.8375 10.2375 0.8375 9.5875 1.4875L8.70625 2.36875L2.68125 8.39375C2.5 8.575 2.3875 8.8125 2.36875 9.06875L2.2 10.9C2.18125 11.1312 2.2625 11.3562 2.425 11.525C2.575 11.675 2.76875 11.7562 2.975 11.7562ZM10.8063 1.91875C11.0063 1.91875 11.2063 1.99375 11.3563 2.15L11.8 2.59375C11.873 2.66553 11.931 2.75113 11.9706 2.84556C12.0102 2.93999 12.0306 3.04136 12.0306 3.14375C12.0306 3.24614 12.0102 3.34751 11.9706 3.44194C11.931 3.53637 11.873 3.62197 11.8 3.69375L11.25 4.24375L9.70625 2.7L10.2563 2.15C10.4062 2 10.6063 1.91875 10.8063 1.91875ZM3.3 9.15625C3.3 9.11875 3.31875 9.0875 3.34375 9.0625L9.0375 3.3625L10.5813 4.90625L4.8875 10.6C4.8875 10.6 4.825 10.6438 4.79375 10.6438L3.15 10.7937L3.3 9.15V9.15625ZM14.2188 13.75C14.2188 14.0063 14.0063 14.2188 13.75 14.2188H1.25C0.99375 14.2188 0.78125 14.0063 0.78125 13.75C0.78125 13.4937 0.99375 13.2812 1.25 13.2812H13.75C14.0063 13.2812 14.2188 13.4937 14.2188 13.75Z"
      fill="#628478"
    />
  </svg>
);

export const BtnFilefold = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.86667 1.75C9.1744 1.75438 9.46793 1.88018 9.68333 2.1L11.9 4.31667C12.1198 4.53207 12.2456 4.8256 12.25 5.13333V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V2.91667C1.75 2.60725 1.87292 2.3105 2.09171 2.09171C2.3105 1.87292 2.60725 1.75 2.91667 1.75H8.86667Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.91671 12.25V8.16671C9.91671 8.012 9.85525 7.86362 9.74585 7.75423C9.63646 7.64483 9.48808 7.58337 9.33337 7.58337H4.66671C4.512 7.58337 4.36362 7.64483 4.25423 7.75423C4.14483 7.86362 4.08337 8.012 4.08337 8.16671V12.25"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.08337 1.75V4.08333C4.08337 4.23804 4.14483 4.38642 4.25423 4.49581C4.36362 4.60521 4.512 4.66667 4.66671 4.66667H8.75004"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
